import { useState, useCallback } from 'react';

const MAX_FILE_SIZE = 100 * 1024; // 100KB

export function useAvatarUpload() {
  const [uploadedAvatar, setUploadedAvatar] = useState<string | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFileSelect = useCallback((file: File) => {
    if (!file.type.startsWith('image/')) {
      setError('Please select an image file.');
      return;
    }
    if (file.size > MAX_FILE_SIZE) {
      setError('Image too large. Please use an image smaller than 100KB.');
      return;
    }
    setIsUploading(true);
    setError(null);
    const reader = new FileReader();
    reader.onload = (e) => {
      setUploadedAvatar(e.target?.result as string);
      setIsUploading(false);
    };
    reader.onerror = () => {
      setError('Failed to read file.');
      setIsUploading(false);
    };
    reader.readAsDataURL(file);
  }, []);

  const clearUpload = useCallback(() => {
    setUploadedAvatar(null);
    setError(null);
  }, []);

  return { uploadedAvatar, isUploading, error, handleFileSelect, clearUpload };
}
